import LoadingScreen from "../../components/StatusScreens/MediumLoadingScreen";
import ErrorAlert from "../../components/Cards/ErrorAlertCard";
import React from "react";
import { useAxios } from "../../hooks/useAxios";
import { useLocation } from "react-router";
import {
  Apresentacao,
  MaisRecentes,
  SessaoConteudo,
} from "../../components/page_components/DetalhesNoticiaPage";

function Noticia() {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const url = `/noticias/${splitLocation[splitLocation.length - 1]}/`;

  const { loading, error, response } = useAxios({
    method: "GET",
    url: url,
    headers: {
      accept: "*/*",
    },
  });

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          {error && (
            <div
              style={{ height: "500px", display: "flex", alignItems: "center" }}
            >
              <ErrorAlert
                descricao={"Não foi possível mostrar a notícia."}
                erroMsg={error}
              />
            </div>
          )}
          {response && (
            <div>
              <Apresentacao noticia={response.dados.noticia} />
              <SessaoConteudo noticia={response.dados.noticia} />
              <MaisRecentes noticias={response.dados.noticias_mais_recentes} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Noticia;
